export const ENV = process.env.NODE_ENV || 'development';
export const IS_DEVELOPMENT = ENV === 'development';
